import React, { lazy, Suspense } from 'react'
import {
  completeInsightsRouteChunkMeasure,
  startInsightsRouteChunkMeasure,
} from '../performance/insightsPerformance'

let routeLoadStarted = false

const markRouteLoadStarted = () => {
  if (routeLoadStarted) return
  routeLoadStarted = true
  startInsightsRouteChunkMeasure()
}

const markRouteLoadFailed = (error) => {
  completeInsightsRouteChunkMeasure('error')
  throw error
}

const LazyInsightsView = lazy(() => import(/* webpackChunkName: "InsightsView" */ '../components/common/InsightsView').catch(markRouteLoadFailed))
const InsightsRoutePreloadProbe = lazy(() => import('../components/common/InsightsView/InsightsRoutePreloadProbe').catch(markRouteLoadFailed))

export function InsightsView(props) {
  markRouteLoadStarted()
  return <LazyInsightsView {...props} />
}

export function InsightsRoutePreloader() {
  markRouteLoadStarted()
  return (
    <Suspense fallback={null}>
      <InsightsRoutePreloadProbe />
    </Suspense>
  )
}
